export default __webpack_public_path__ + "static/media/excel.0702e5b6.png";